angular.module('cfn').directive('dBtnToggle', function() {
  return {
    restrict: 'E',
    require: '?ngModel',
    template: function(elem, attr, var3) {
      return (
        '<input class="toggle" ng-model="' +
        attr.ngModel +
        '" type="checkbox"><label class="toggle-btn"> </label>'
      );
    },
    link: function(scope, element, attrs, ngModel) {
      element.click(function() {
        ngModel.$setViewValue(!ngModel.$modelValue);
      });
    }
  };
});
